<template>
  <div class="main" style="margin: 10px;">
    <div class="container" style="height: 55px; padding-bottom: 10px;">
      <div class="image2">
        <el-image :src="'./images/gda-log.png'" />
      </div>
    </div>
    <div v-if="store.state.redeemResult.code=='ok'">
      <h2>{{getI18n('兑换成功, 二维码已发到你的邮箱', 'redeem success, We\'ve sent the QR code to your email')}}</h2>
      <div v-if="store.state.redeemResult.data.qrcode!=''">
        <!-- <img :src="store.state.redeemResult.data.qrcode" class="image-style" style="width: 350px;"/> -->
         <img :src="'data:image/png;base64,'+store.state.redeemResult.data.qrcode" class="image-style" style="width: 350px;"/>
      </div>
    </div>
    <div v-else>
      <h2>{{getI18n('兑换失败', 'redeem fail')}}:{{ store.state.redeemResult.message }}</h2>
    </div>
    <el-divider />
    <div><a href="/" target="_blank"><h2>{{getI18n('查询流量 & FAQ', 'Check Data & FAQ')}}</h2></a></div>
    <el-divider />
    <div class="links-container">
      <a href="https://sg.shp.ee/Wn1Z7zM" class="qr-link" target="_blank">
        <span>Click to go to our Shopee store</span>
        <!-- https://sg.shp.ee/Wn1Z7zM -->
        <!-- https://shopee.sg/gda_global_data -->
        <img src="/images/redeem/shopee-qrcode.png" class="image-style" style="width: 150px;" />
      </a>
      <a href="https://www.lazada.sg/shop/gda-global-data-assistant" class="qr-link" target="_blank">
        <span>Click to go to our Lazada store</span>

        <!-- https://www.lazada.sg/shop/gda-global-data-assistant -->
        <img src="/images/redeem/lazada-qrcode.png" class="image-style" style="width: 150px;" />
        <!-- https://s.lazada.sg/s.cmc1Q -->
      </a>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted } from 'vue'
import store from '../store'
import { getI18n } from '../utils'

export default defineComponent({
  name: 'RedeemGiftResultView'
})
</script>

<script lang="ts" setup>
onMounted(async () => {
  console.log('RedeemGiftResultView', store)
})
</script>

<style scoped>
.container {
  position: relative;
}
.links-container {
  display: flex;
  justify-content: space-around;
  align-items: center;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;
}
.qr-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-decoration: none;
  color: inherit;
  margin: 0 10px;
}
@media screen and (min-width: 600px) {
  .main {
    max-width: 600px; /* 或根据需要设置为其他宽度 */
    width: 600px;
    margin: 0 auto; /* 使内容居中 */
    padding: 0 10px; /* 给两边留一些空白 */
  }
}
</style>
